<div class="regel-editor regel-ongekwalificeerd">
  <div class="regel-header d-flex align-items-center justify-content-between mb-2">
    <div class="d-flex align-items-center">
      <span class="badge badge-warning mr-2">{{ regelTypeNamen[regel.context].label }}</span>
    </div>
    <filterregel-acties
      [clausuleId]="clausuleId!"
      [isInRootGroep]="isInRootGroep"
      (uitDezeGroep)="uitDezeGroep.emit($event)"
      (wikkelInEn)="wikkelInEn.emit($event)"
      (wikkelInOf)="wikkelInOf.emit($event)"
      (verwijder)="verwijder.emit($event)"></filterregel-acties>
  </div>

  <div class="regel-body">
    <small class="text-muted">{{ regelTypeNamen[regel.context].omschrijving }}</small>
  </div>
</div>
